import getCurrentQuery from '../utils/getCurrentQuery'
import R from 'ramda'

export default (state) => {
  const query = getCurrentQuery()
  const {provinces, regions, towns} = query
  
  const provincesOptions = state.options.provinces
  const regionsOptions = state.options.regions
  const townsOptions = state.options.towns

  const leafProvinces = R.reject((provinceId)=> {
    return R.any((regionId)=> {
      const r = R.find(R.propEq('id', regionId), regionsOptions)
      return r.parent == provinceId
    },regions)
  } , provinces)
  
  const leafRegions = R.reject((regionId)=> {
    return R.any((townId)=> {
      const t = R.find(R.propEq('id', townId), townsOptions)
      return t.parent == regionId
    },towns)
  } , regions)
  return R.flatten([towns, leafRegions, leafProvinces])
}




/** WEBPACK FOOTER **
 ** ./app/utils/getLeafGeographicalZoneIds.js
 **/